import { lazy } from 'react';

const LazyApiKeyManagementView = lazy(() => import('./api-key-management-view'));
export default LazyApiKeyManagementView;
